import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { SERVICES } from "@/lib/site";
import { fadeUp } from "@/lib/anim";

export const Services = () => {
  const [active, setActive] = useState(0);

  return (
    <section id="services" data-testid="services-section" className="border-b border-line">
      <div className="mx-auto max-w-[1600px] px-5 md:px-10 py-20 md:py-28">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10">
          <div className="lg:col-span-4">
            <p className="font-mono text-[11px] uppercase tracking-[0.3em] text-acid mb-5">/ 01 — Capabilities</p>
            <h2 className="font-display font-black tracking-tighter leading-[0.9] text-5xl md:text-6xl">
              WHAT WE<br />KEEP CLEAN
            </h2>
            <p className="mt-6 text-white/55 max-w-sm leading-relaxed">
              One accountable partner across every surface in your building. Hover a service to preview the work.
            </p>

            {/* Spotlight preview */}
            <div className="relative mt-10 hidden lg:block aspect-[4/3] border border-line overflow-hidden">
              <AnimatePresence mode="wait">
                <motion.img
                  key={active}
                  src={SERVICES[active].image}
                  alt={SERVICES[active].title}
                  initial={{ opacity: 0, scale: 1.08 }}
                  animate={{ opacity: 1, scale: 1 }}
                  exit={{ opacity: 0 }}
                  transition={{ duration: 0.5 }}
                  className="absolute inset-0 h-full w-full object-cover grayscale contrast-125"
                />
              </AnimatePresence>
              <div className="absolute inset-0 bg-gradient-to-t from-ink-900/60 to-transparent" />
              <div className="absolute bottom-4 left-4 flex gap-2 flex-wrap">
                {SERVICES[active].tags.map((t) => (
                  <span key={t} className="font-mono text-[10px] uppercase tracking-widest bg-acid text-ink-900 px-2 py-1">{t}</span>
                ))}
              </div>
            </div>
          </div>

          <div className="lg:col-span-8 lg:border-l lg:border-line">
            {SERVICES.map((s, i) => (
              <motion.button
                key={s.no}
                data-testid={`service-item-${s.no}`}
                variants={fadeUp}
                custom={i}
                initial="hidden"
                whileInView="show"
                viewport={{ once: true, margin: "-80px" }}
                onMouseEnter={() => setActive(i)}
                onFocus={() => setActive(i)}
                onClick={() => document.querySelector("#quote")?.scrollIntoView({ behavior: "smooth" })}
                className={`group w-full text-left border-b border-line lg:pl-10 py-8 md:py-10 transition-colors duration-300 ${
                  active === i ? "bg-ink-800" : "bg-transparent"
                }`}
              >
                <div className="flex items-start justify-between gap-6">
                  <div className="flex items-start gap-5 md:gap-8">
                    <span className="font-mono text-xs text-acid pt-2">{s.no}</span>
                    <div>
                      <h3 className="font-display font-black tracking-tight text-3xl md:text-5xl leading-none group-hover:translate-x-1.5 transition-transform duration-300">
                        {s.title}
                      </h3>
                      <p className="mt-3 text-white/55 max-w-lg leading-relaxed">{s.desc}</p>
                    </div>
                  </div>
                  <span className="shrink-0 grid place-items-center h-11 w-11 border border-line text-white/50 group-hover:bg-acid group-hover:text-ink-900 group-hover:border-acid transition-colors">
                    <ArrowUpRight size={18} />
                  </span>
                </div>
              </motion.button>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};
